export default __webpack_public_path__ + "static/media/BACHILLER-DIGITAL-01.b0309d27.png";